import * as React from 'react';

const Cross = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={18} {...props}>
        <defs>
            <filter id="cross_a" width="178.6%" height="200%" x="-39.3%" y="-40.9%" filterUnits="objectBoundingBox">
                <feOffset dy={24} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={40} />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0.229949097 0 0 0 0 0.461254077 0 0 0 0 0.62647192 0 0 0 0.0533333333 0"
                />
                <feOffset dy={16} in="SourceAlpha" result="shadowOffsetOuter2" />
                <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation={12} />
                <feColorMatrix
                    in="shadowBlurOuter2"
                    result="shadowMatrixOuter2"
                    values="0 0 0 0 0.231372549 0 0 0 0 0.462745098 0 0 0 0 0.62745098 0 0 0 0.0266666667 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
            </filter>
            <rect id="cross_b" width={336} height={264} x={0} y={0} rx={8} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <use xlinkHref="#cross_b" fill="currentColor" filter="url(#cross_a)" transform="translate(-295 -19)" />
            <path
                fillRule="nonzero"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m1.5 16.5 15-15m0 15-15-15"
            />
        </g>
    </svg>
);
export default Cross;
